import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function Home() {

    const { t } = useTranslation();
    return (
        <Box sx={{ textAlign:'center', alignItems: 'center' }}>
            <Typography>{t('HOME.TITLE')}</Typography>
        </Box>
    );
}
